import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import styled from '@emotion/styled';
import Modal from '@amzn/meridian/modal';
import Column from '@amzn/meridian/column';
import { rio } from '@amzn/rio-design-tokens';
import { ImageSlider } from 'src/common/imageSlider';
import { InvisibleButton } from 'src/common/buttons';
import { ScrollableRow } from 'src/common/styled';
import { handleButtonFocus } from 'src/utils/accessibilityUtils';
import { usePageContext } from 'src/hooks';
const ImageButton = styled(InvisibleButton) `
  margin: 4px !important; /* !important needed to override Meridian Row spacing otherwise top/bottom outline is clipped */

  &:focus {
    outline: 2px solid ${({ theme }) => theme.rio.semantic.color.border.interactive};
    outline-offset: 2px;
    border-radius: ${rio.semantic.size.radius.medium};
  }
`;
// Square tiles, cropped to fill, as on Amazon retail. Review images come without dimensions, so a fixed box (also
// set as the img's width and height) keeps a lazy-loaded image from starting at 0px wide and pushing the row on load.
const REVIEW_IMAGE_SIZE = 160;
const StyledReviewImage = styled.img `
  width: ${REVIEW_IMAGE_SIZE}px;
  height: ${REVIEW_IMAGE_SIZE}px;
  object-fit: cover;
  border-radius: ${rio.semantic.size.radius.medium};
  display: block;
`;
export const ReviewImages = ({ images }) => {
    const { bundle } = usePageContext();
    const [activeSlideIndex, setActiveSlideIndex] = useState(0);
    const [open, setOpen] = useState(false);
    const onClose = () => setOpen(false);
    const onOpen = (index) => {
        setActiveSlideIndex(index);
        setOpen(true);
    };
    return (_jsxs(Column, { spacingInset: "200 none", spacing: "none", children: [_jsx(ScrollableRow, { spacingInset: "none", spacing: "300", "data-testid": "review-images", children: _jsx("ul", { role: "list", "aria-label": bundle.formatMessage('reviewImagesList', { count: images.length }), style: { display: 'contents' }, children: images.map((image, index) => (_jsx("li", { role: "listitem", style: { listStyle: 'none', display: 'contents' }, children: _jsx(ImageButton, { onClick: () => onOpen(index), onFocus: handleButtonFocus, "aria-label": bundle.getMessage('reviewImage'), children: _jsx(StyledReviewImage, { loading: "lazy", width: REVIEW_IMAGE_SIZE, height: REVIEW_IMAGE_SIZE, src: image.highRes, alt: image.altText, onError: (e) => {
                                    // Fallback to lowRes if hiRes fails
                                    const target = e.target;
                                    if (target.src !== image.lowRes) {
                                        target.src = image.lowRes;
                                    }
                                } }) }) }, `${image.altText} ${index}`))) }) }), _jsx(Modal, { title: " ", bodySpacingInset: "none", open: open, onClose: onClose, fullscreenBreakpoint: 3000, "data-testid": "modal-review-images", children: _jsx(ImageSlider, { images: images, initialSlide: activeSlideIndex, fullScreen: "true", loop: false, showPagination: false }) })] }));
};
